import {WinPresentationController} from "../WinPresentationController";
import {TheRave} from "../../TheRave";
import {TimelineLite} from "gsap";

export class FreespinNoWinPause extends WinPresentationController {

    constructor() {
        super("FreespinNoWinPause", false);
    }

    protected hasWin():boolean {
        const data = TheRave.model.parsedGameData;
        return data.isFreespin && data.singleWin === 0;
    }

    protected async createWinAnimation():Promise<any> {
        const tl = new TimelineLite().add(()=>{}, 0.5);
        await Promise.resolve(tl);
    }
}